export default function Videos() {

  $(document).ready(function() {


    // ==========================================================================
    // Any video with a class of '.no-controls' should play/pause automatically
    // when it is in the middle of the viewport.
    // ==========================================================================

    var noControlsVideos  = $('.no-controls');
    var tolerancePixel    = 200;

    function checkNoControlsVideos() {
      var scrollTop     = $(window).scrollTop() + tolerancePixel;
      var scrollBottom  = $(window).scrollTop() + $(window).height() - tolerancePixel;

      noControlsVideos.each(function(index, el) {
        var yVideoTop     = $(this).offset().top;
        var yVideoBottom  = $(this).height() + yVideoTop;

        if (scrollTop < yVideoBottom && scrollBottom > yVideoTop) {
          $(this).get(0).play();
        } else {
          $(this).get(0).pause();
        }
      });
    }

    $(document).on('scroll', checkNoControlsVideos);


    // ==========================================================================
    // Any video with a class of '.has-controls' will start with a custom play
    // button that, when clicked, will disappear. At the same moment, the OS's
    // native controls will appear / take over.
    // ==========================================================================

    var hasControlsVideos = $('.has-controls');

    hasControlsVideos.each(function(index, el) {
      var video       = $(this).find('video');
      var customPlay  = $(this).find('.has-controls__play');

      $(customPlay).on('click', function() {
        $(this).hide();
        $(video).get(0).play();
        $(video).attr('controls', true);
      });
    });


  });

}
